export const UPDATE_AUTH_USER_INFO = 'auth_user/UPDATE_AUTH_USER_INFO'
